import React, { useEffect, useState } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import { Button, Form, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  getAccountOwnersList,
  getLeadByID,
  setNewDataLead,
  setUpWorkData,
} from '../../redux/reduxActions/leadActions';
import { showToastError } from '../utils';

const SetUpWorkLeadData = (props) => {
  const [upWorkId, setUpWorkId] = useState('');
  const [inviteId, setInviteId] = useState('');
  const [agency, setAgency] = useState(false);
  const [accountOwner, setAccountOwner] = useState('');
  const [emailInviteLink, setEmailInviteLink] = useState('');
  const {
    accountsOwner, funnelStatuses, selectedLead: { upwork_records }, selectedLead,
  } = props;
  // console.log(upwork_records)
  const SetUpWorkData = async () => {
  	if (!upWorkId || !accountOwner) {
      showToastError('Fill in required fields');
      return;
    }
  	const upWorkData = {
      id: selectedLead.upwork_records ? selectedLead.upwork_records.id : null,
      job_id: upWorkId,
      invite_id: inviteId,
      agency,
      account_owner: parseInt(accountOwner, 10),
      invite_link: emailInviteLink,
      lead_id: selectedLead.id,
	  };

  	const res = await props.setUpWorkData(upWorkData);
  	// console.log(res);
  	props.setNewDataLead(selectedLead.id, { funnel_status: funnelStatuses.find((item) => item.name === 'UpWork Data Added').id, upwork_record_id: res.data.id }, props.history.push, false);
  };

  useEffect(() => {
  	props.getAccountOwnersList();
	  props.getLeadByID(props.match.params.id);
  }, []);
  useEffect(() => {
  	if (upwork_records) {
      setEmailInviteLink(upwork_records.invite_link || '');
		  setInviteId(upwork_records.invite_id || '');
		  setAgency(upwork_records.agency || '');
		  setUpWorkId(upwork_records.job_id || '');
		  setAccountOwner(upwork_records.account_owner || '');
	  }
  }, [props]);
  return (
    <div>
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <h3 style={{ color: '#383838', marginBottom: 10 }}>Set UpWork Data</h3>
          <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
            <p className="lead__title">
						  UpWork job id:
              <span style={{ color: 'red' }}>*</span>
            </p>
            <TextareaAutosize
              onChange={(e) => setUpWorkId(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
              placeholder="..."
              defaultValue={upWorkId}
            />
            <a
              className="input-text-button"
              href={`https://www.upwork.com/jobs/~${upWorkId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
	            Link
            </a>
          </div>
          <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
            <p className="lead__title">
			        Invite id:
            </p>
            <TextareaAutosize
              onChange={(e) => setInviteId(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
              placeholder="..."
              defaultValue={inviteId}
            />
            <a
              href={`https://www.upwork.com/ab/proposals/interview/${inviteId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="input-text-button"
            >
						Link
            </a>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
	            Account Owner:
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group style={{ width: '50%' }} controlId="formGridState">
              <FormControl
                value={accountOwner}
                as="select"
                onChange={({ target }) => {
	                setAccountOwner(target.value);
							  }}
              >
                <option key="" value="">none</option>
                {
	                accountsOwner.map((item) => (
  <option key={item.id} value={item.id}>
    {item.account_owner}
  </option>
	                ))
}
              </FormControl>
            </Form.Group>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
						  Agency
            </p>
            <Form.Group controlId="formBasicCheckbox">
              <Form.Check checked={agency} onChange={() => setAgency(!agency)} type="checkbox" />
            </Form.Group>
          </div>
          <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
            <p className="lead__title">
			        Invite link from e-mail:
            </p>
            <TextareaAutosize
              onChange={(e) => setEmailInviteLink(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0, minHeight: '48px' }}
              placeholder="..."
              defaultValue={emailInviteLink}
            />
            <a
              href={emailInviteLink}
              target="_blank"
              className="input-text-button"
            >
	            Link
            </a>
          </div>
          <Button
            onClick={() => SetUpWorkData()}
            variant="primary"
            style={{ marginLeft: '88%', marginTop: 20 }}
            className="main-button-filled"
          >
					  Save
          </Button>
        </div>
      </div>
    </div>
  );
};
export default connect((store) => ({
  accountsOwner: store.leadReducer.accountsOwner,
  selectedLead: store.leadReducer.selectedLead,
  funnelStatuses: store.leadReducer.funnelStatuses,
}), {
  getAccountOwnersList,
  getLeadByID,
  setNewDataLead,
  setUpWorkData,
})(SetUpWorkLeadData);
